//   > getReport > `/patients/${patientId}/reports/${reportId}?format=...

import http from '../../../lib/http'
import { notify } from '../../../lib/Notification/actions.js'

export const GET_REPORT = 'GET_REPORT'
export const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS'
export const GET_REPORT_FAILURE = 'GET_REPORT_FAILURE'

export const GET_HTML_REPORT = 'GET_HTML_REPORT'
export const GET_HTML_REPORT_SUCCESS = 'GET_HTML_REPORT_SUCCESS'
export const GET_HTML_REPORT_FAILURE = 'GET_HTML_REPORT_FAILURE'

export const SHARE_REPORT = 'SHARE_REPORT'
export const SHARE_REPORT_SUCCESS = 'SHARE_REPORT_SUCCESS'
export const SHARE_REPORT_FAILURE = 'SHARE_REPORT_FAILURE'

export const GET_AUDIT_LOG = 'GET_AUDIT_LOG'
export const GET_AUDIT_LOG_SUCCESS = 'GET_AUDIT_LOG_SUCCESS'
export const GET_AUDIT_LOG_FAILURE = 'GET_AUDIT_LOG_FAILURE'

export function getReport (patientId, reportType, reportId, reportFormat) {
  return dispatch => {
    dispatch({ type: GET_REPORT })
    return http
      .getRequest(
        `/patients/${patientId}/reports/${reportId}?format=${reportFormat}&downloadType=encoded&reportType=${reportType}`
      )
      .then(response => {
        const reportContents = response.data
        dispatch({
          type: GET_REPORT_SUCCESS,
          reportContents
        })
      })
      .catch(err => dispatch({
        type: GET_REPORT_FAILURE,
        error: err
      }))
  }
}

export function getHtml (patientId, reportType, reportId) {
  return dispatch => {
    dispatch({ type: GET_HTML_REPORT })
    return http
      .getRequest(
        `/patients/${patientId}/reports/${reportId}?format=html&downloadType=encoded&reportType=${reportType}`
      )
      .then(response => {
        const reportHtml = response.data
        dispatch({
          type: GET_HTML_REPORT_SUCCESS,
          reportHtml
        })
      })
      .catch(err => dispatch({
        type: GET_HTML_REPORT_FAILURE,
        error: err
      }))
  }
}

export function getAuditLog (patientId, reportId) {
  return dispatch => {
    dispatch({ type: GET_AUDIT_LOG })
    return http
      .getRequest(`/patients/${patientId}/reports/${reportId}/events/audit/log`)
      .then(response => {
        dispatch({
          type: GET_AUDIT_LOG_SUCCESS,
          auditLog: response
        })
      })
      .catch(() =>
        dispatch({
          type: GET_AUDIT_LOG_FAILURE,
          auditLogError: true
        }))
  }
}

export function shareReport (
  patientId,
  reportType,
  reportId,
  communicationMedium,
  formData
) {
  return dispatch => {
    dispatch({ type: SHARE_REPORT })
    return http
      .postRequest(
        `/patients/${patientId}/reports/${reportId}?communicationMedium=${communicationMedium}&reportType=${reportType}`,
        formData
      )
      .then(() => {
        dispatch({ type: SHARE_REPORT_SUCCESS })
        dispatch(getAuditLog(patientId, reportId))
        dispatch(notify('The document was sent successfully.', false))
      })
      .catch(() => {
        dispatch({ type: SHARE_REPORT_FAILURE })
        dispatch(getAuditLog(patientId, reportId))
        dispatch(notify('There was an error sending the document.', true))
      })
  }
}
